import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

console.log('process.env.NODE_ENV', process.env.NODE_ENV)
export default new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'development' ? '/' : '/homepage/',
  routes: [
    
    {
      path: '/',
      name: 'home',
      component: Home,
      meta : {
        title:'Home'
      },
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      meta : {
        title:'About'
      },

    },
    {
      path: '/links',
      name: 'links',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Links.vue'),
      meta : {
        title:'リンク'
      },

    },
    {
      path: '/app/:appname',
      name: 'apppage',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "apppage" */ './views/AppPage.vue'),
      props:true,
      meta : {
        titlefunc(to) {
          return to.params.appname
        }
      },

    }
  ]
})
